import { Component } from '@angular/core';
import { AlertMessageService } from '../../services/alert-message.service';
import { AlertMessageModel, AlertMessageModelNav } from '../../models/common.model';

@Component({
  selector: 'app-error-alert-popup-ctba',
  templateUrl: './error-alert-popup-ctba.component.html',
  styleUrls: ['./error-alert-popup-ctba.component.css']
})
export class ErrorAlertPopupCTBAComponent {
headerTitle:string="Error";
  messageText:string="Client name is required";
  buttonText:string="Close"
  showError:boolean=false;
  displayValue:string = "";
  heightValue:string = "";
  Selection:string = "";
  navigationText:string = "";
  PanelList: any = [
    { iconClass: "", displayLabel: "Column", hasAccess: false },
    { iconClass: "", displayLabel: "Column Nesting", hasAccess: false},
    { iconClass: "", displayLabel: "Row", hasAccess: false },
    { iconClass: "", displayLabel: "Row Nesting", hasAccess: false },
    { iconClass: "", displayLabel: "Filters", hasAccess: false}
  ]
  constructor(private _alertService:AlertMessageService){
    
  }
  ngOnInit() {
    this._alertService.isAlert2$.subscribe((alert:AlertMessageModelNav) => {
      this.showError = alert.show;
      this.headerTitle=alert.header;
      this.messageText=alert.message;
      this.Selection=alert.Selection;
      this.navigationText = alert.text;
      if(this.Selection!=undefined){
          const selectedItems = this.Selection.split('/');
          this.PanelList.forEach((item:any) => {
            if (selectedItems.includes(item.displayLabel)) {
              item.hasAccess = true;
            }
            else{
              item.hasAccess = false;
            }
          });
        }
    });
  }
  close(){
    this.showError=false;
  }
  onOkBtnClick(){
    this.showError=false;
  }
  customcss(messageText:any){
    if(messageText.length != 0){
      if(messageText.length > 300){
        this.heightValue = '100%';
        return '';
      }
      else{
        this.heightValue = '';
        return '';
       
      }
    }
    return '';
  } 
}
